import { render, staticRenderFns } from "./EmptyActivities.vue?vue&type=template&id=30b4bd14&scoped=true"
import script from "./EmptyActivities.vue?vue&type=script&lang=ts"
export * from "./EmptyActivities.vue?vue&type=script&lang=ts"
import style0 from "./EmptyActivities.vue?vue&type=style&index=0&id=30b4bd14&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b4bd14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30b4bd14')) {
      api.createRecord('30b4bd14', component.options)
    } else {
      api.reload('30b4bd14', component.options)
    }
    module.hot.accept("./EmptyActivities.vue?vue&type=template&id=30b4bd14&scoped=true", function () {
      api.rerender('30b4bd14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/EmptyActivities.vue"
export default component.exports